import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function ProtectedRoute({ children }) {
    const { isAuthenticated, authLoading } = useAuth();

    if (authLoading) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Roboto, sans-serif', color: '#888' }}>
                <i className="far fa-spinner fa-spin" style={{ marginRight: 8 }}></i> Loading...
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/manage/login" replace />;
}

export default ProtectedRoute;
